import { render, staticRenderFns } from "./datashareTest.vue?vue&type=template&id=7d54e11a&scoped=true"
import script from "./datashareTest.vue?vue&type=script&lang=js"
export * from "./datashareTest.vue?vue&type=script&lang=js"
import style0 from "./datashareTest.vue?vue&type=style&index=0&id=7d54e11a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d54e11a",
  null
  
)

export default component.exports